// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const ModalStyle = css`
  &.TCPModal__Overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: ${(props) => props.theme.colors.MODAL_OVERLAY};
    z-index: ${(props) => props.theme.zindex.zModal};
    @media ${(props) => props.theme.mediaQuery.small} {
      max-height: 100vh;
      max-width: 100%;
    }
  }

  &.TCPModal__Overlay.filter-sort-styles {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      max-width: 100%;
    }
  }

  &.TCPModal__Overlay.hide-overlay {
    display: none !important;
  }

  .TCPModal__hidden_header_label {
    display: none;
  }
  div.TCPModal__InnerContent {
    background: ${(props) => props.theme.colors.WHITE};
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: ${(props) => (props.noPadding ? '0' : props.theme.spacing.ELEM_SPACING.LRG)};
    transform: translate(-50%, -50%);
    overflow-y: auto;
    height: 100%;
    width: ${(props) => (props.fixedWidth ? '100%' : '')};
    @media ${(props) => props.theme.mediaQuery.medium} {
      height: ${(props) => (props.heightConfig ? props.heightConfig.height : 'auto')};
      max-width: ${(props) => (props.fixedWidth ? props.maxWidth : '')};
      min-height: ${(props) => (props.fixedWidth ? props.minHeight : '')};
      width: ${(props) => (props.widthConfig ? props.widthConfig.medium : '')};
      max-height: ${(props) => (props.heightConfig ? props.heightConfig.maxHeight : '')};
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      width: ${(props) => (props.widthConfig ? props.widthConfig.large : '')};
      min-height: ${(props) => (props.heightConfig ? props.heightConfig.minHeight : '')};
      height: ${(props) => (props.heightConfig ? props.heightConfig.height : 'auto')};
      max-height: ${(props) => (props.heightConfig ? props.heightConfig.maxHeight : '')};
    }

    @media ${(props) => props.theme.mediaQuery.smallMax} {
      ${(props) =>
        props.spc
          ? `
           top: 70%;
           border-radius: ${props.theme.spacing.ELEM_SPACING.SM};
           overflow: scroll;
           padding-left: ${props.theme.spacing.LAYOUT_SPACING.XXS};
           padding-right: ${props.theme.spacing.LAYOUT_SPACING.XXS};`
          : ''}
    }

    ${(props) =>
      props.standardHeight
        ? `@media ${props.theme.mediaQuery.medium} {
      max-height:90%
    } `
        : ''}
  }
  .Modal_Heading {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    border-bottom: 3px solid ${(props) => props.theme.colors.BLACK};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    margin-top: 0;
    height: 20px;
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    padding-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }

  .back-button {
    border-style: solid;
    border-color: black;
    border-image: initial;
    border-width: 0px 1.5px 1.5px 0px;
    display: inline-block;
    padding: 5px;
    transform: rotate(135deg);
    position: absolute;
    top: 13px;
    left: 18px;
  }

  .back-to-qv-button-wrapper {
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    padding: 6px;
    height: 29px;
    width: 29px;
    margin: 10px 0 0 20px;
    background: white;
    cursor: pointer;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 32px;
      width: 32px;
    }
  }

  .back-to-qv-button-left-arrow {
    height: 15px;
    width: 15px;
    @media ${(props) => props.theme.mediaQuery.large} {
      height: 18px;
      width: 18px;
    }
  }

  .Modal-Header {
    ${(props) =>
      props.stickyHeader
        ? `
    top:0px;
    position:sticky;
    background:#ffffff;
    `
        : ''};
  }
  ${(props) =>
    !props.heading
      ? `
        .alignTop {
      top: ${props.theme.spacing.ELEM_SPACING.MED};
      z-index: 1;
        }
    `
      : null}
  ${(props) => (props.inheritedStyles ? props.inheritedStyles : '')};
`;
export default ModalStyle;
